"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modelspace = exports.handleProject = exports.handleCustomer = exports.initialState = void 0;
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const customerReducer = require("./customer");
const projectReducer = require("./project");
exports.initialState = {
    customer: Object.assign({}, customerReducer.initialState),
    project: Object.assign({}, projectReducer.initialState)
};
const customerLens = monocle.Lens.fromProp('customer');
const projectLens = monocle.Lens.fromProp('project');
const handleCustomer = (action) => (state) => {
    const fn = customerReducer.methods[action.type];
    if (fn) {
        const current = customerLens.get(state);
        return customerLens.set(fn(current, action))(state);
    }
    return state;
};
exports.handleCustomer = handleCustomer;
const handleProject = (action) => (state) => {
    const fn = projectReducer.methods[action.type];
    if (fn) {
        const current = projectLens.get(state);
        return projectLens.set(fn(current, action))(state);
    }
    return state;
};
exports.handleProject = handleProject;
const modelspace = (state = Object.assign({}, exports.initialState), action) => {
    return fp.function.compose((0, exports.handleCustomer)(action), (0, exports.handleProject)(action))(state);
};
exports.modelspace = modelspace;
//# sourceMappingURL=index.js.map